<template lang="pug">
article-item-page-template(:title="pageTitle", :loading="loading")
  template(#header)
    .text-h6(v-html="content.title")
    //- v-chip.mb-3.ml-auto
    //-   v-icon(small, left) far fa-clock
    //-   span {{ formatDate(content.scheduled) }}
  template(#main)
    v-img.rounded.bordered.mb-2(
      :src="files + '/' + content.mainImg",
      max-height="400px",
      contain
    )
    .ck-content(v-html="content.text")
</template>

<script>
import ArticleItemPageTemplate from "@/components/templates/ArticleItemPage";

const _config = {
  title: "Comunicados",
  mod: "communications",
};

export default {
  data: () => ({
    loading: false,
    pageTitle: _config.title,
  }),
  computed: {
    itemId() {
      return this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1");
    },
    content() {
      return this.$rest(_config.mod).item;
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    formatDate(date) {
      return new Intl.DateTimeFormat("pt-BR", {
        dateStyle: "long",
        timeStyle: "short",
      }).format(new Date(date));
    },
  },
  created() {
    this.loading = true;
    this.$rest(_config.mod)
      .get({ id: this.itemId })
      .then(() => (this.loading = false))
      .catch(() => {
        this.$router.replace("/error404");
      });
  },
  watch: {
    itemId(v) {
      this.$rest(_config.mod).get({ id: v });
    },
  },
  components: {
    ArticleItemPageTemplate,
  },
};
</script>
